// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { range } from 'lodash'
import { Steps } from 'antd'

/**
@description Renders an Antd Steps component

@param {string} className. Class name for the
stepper. Allows customisation.
E.g. lmc-add-meds-antd-steps

@param {number} currentStep. The current step. E.g.
for the second step, currentStep = 1.

@param {array} stepLabels. Optional array of labels
for the dots in the stepper.

@param {number} finalStepIndex. The index of the final
step. E.g. 4 steps, finalStepIndex = 3

@returns {function} AntdSteps.
*/

export default function AntdSteps(props) {
  const { className, currentStep, stepLabels, finalStepIndex } = props

  const { Step } = Steps

  return (
    <Steps progressDot className={className} current={currentStep}>
      {range(0, finalStepIndex + 1).map((stepNumber) => {
        const title =
          stepLabels && stepLabels.length ? stepLabels[stepNumber] : null

        return <Step title={title} key={stepNumber} />
      })}
    </Steps>
  )
}

AntdSteps.propTypes = {
  className: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  finalStepIndex: PropTypes.number.isRequired,
  stepLabels: PropTypes.array,
}
